import React from 'react';

export interface SectorSLA {
  sectorName: string;
  withinSla: number;
  outsideSla: number;
  rate: number;
  targetTime: number;
}

interface SectorBreakdownProps {
  sectors: SectorSLA[];
}

export const SectorBreakdown: React.FC<SectorBreakdownProps> = ({
  sectors,
}) => {
  return (
    <div className='grid grid-cols-1 gap-3 overflow-y-auto max-h-[200px] pr-1 [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-thumb]:bg-slate-200 [&::-webkit-scrollbar-thumb]:rounded-full hover:[&::-webkit-scrollbar-thumb]:bg-slate-300'>
      {sectors.map((sector) => (
        <div
          key={sector.sectorName}
          className='flex items-center justify-between p-3 rounded-xl bg-slate-50 border border-slate-100 hover:border-violet-200 transition-colors'
        >
          <div className='flex items-center gap-3'>
            <div className='w-10 h-10 rounded-lg bg-white shadow-sm flex items-center justify-center font-black text-slate-700 text-sm border border-slate-100'>
              {sector.sectorName}
            </div>
            <div>
              <div className='text-xs font-bold text-slate-500 uppercase tracking-wide'>
                Meta: {'<'} {sector.targetTime}m
              </div>
              <div className='flex items-center gap-2 mt-1'>
                <div className='flex items-center gap-1 text-[10px] font-bold text-emerald-600 bg-emerald-50/50 px-1.5 py-0.5 rounded-md border border-emerald-100/50'>
                  <div className='w-1.5 h-1.5 rounded-full bg-emerald-500 shadow-sm animate-pulse' />
                  {sector.withinSla}
                </div>
                <div className='flex items-center gap-1 text-[10px] font-bold text-rose-600 bg-rose-50/50 px-1.5 py-0.5 rounded-md border border-rose-100/50'>
                  <div className='w-1.5 h-1.5 rounded-full bg-rose-500 shadow-sm' />
                  {sector.outsideSla}
                </div>
              </div>
            </div>
          </div>

          <div className='flex flex-col items-end'>
            <span
              className={`text-xl font-[1000] tracking-tight ${
                sector.rate >= 80
                  ? 'text-emerald-500'
                  : sector.rate >= 50
                    ? 'text-amber-500'
                    : 'text-rose-500'
              }`}
            >
              {sector.rate.toFixed(1)}%
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};
